import React from "react";
import MasterDataListPage from "../MasterDataListPage";

export default function ColorsPage() {
    return (
        <MasterDataListPage
            title="Master Data"
            subtitle="สี"
            apiPath="/colors" 
            fieldKey="name"
            createDefaultName="รายการใหม่" 
            initialItems={[]}
        />
    );
}
